module.exports = __webpack_public_path__ + "static/media/generation-z.7b9f59f3.jpg";